


import SECTION_VIPBANNERSECTION from
'../dynamic_section/dynamic_2/template_01';





import SECTION_VIPCONTENTSECTION from
'../dynamic_section/dynamic_2/template_01';





import SECTION_VIPCONTENTMSECTION from
'../dynamic_section/dynamic_2/template_01';






import VIPSection from '../sections/vip/default';






import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";


const VipPage = ()=>{
  
return (
  <div id="vipPage" class="page ">
  
  

  
  < SECTION_VIPBANNERSECTION desktopToggle={ true }
    mobileToggle={ false } label={ `vip banner` } id={ `vip_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  < SECTION_VIPBANNERSECTION desktopToggle={ false }
    mobileToggle={ true } label={ `vip banner` } id={ `vip_banner_m` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  

  < SECTION_VIPBANNERSECTION desktopToggle={ true }
    mobileToggle={ false } label={ `vip content` } id={ `vip_content` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
   < SECTION_VIPBANNERSECTION desktopToggle={ false }
    mobileToggle={ true } label={ `vip content m` } id={ `vip_content_m` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />

  
  
  
  

  
  <VIPSection desktopToggle={ false } mobileToggle={
    false } bgSection={ false } mobileTitleToggle={false} mobileBannerToggle={ false } desktopBannerToggle={
    false } mode={``}  vipContentToggle={false} joinNowContentToggle={true}  aboutUsToggle={ false }
    faqToggle={ false }tncToggle={ false } benefitToggle={
    false } reviewToggle={ false } />
  
  
  
  

  
  {/* < SECTION_FOOTER_BANNER desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `footer_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } /> */}
  
  
  

  
</div>
)
}

export default VipPage;